module Client.Components.EquipmentInfo

open Shared
open global.Elmish
open Feliz
open Feliz.MaterialUI
    
let view (equipment : Shared.Equipment) =
  Mui.grid [
    grid.container true
    grid.direction.column
    grid.spacing._2
    grid.children [
      Mui.grid [
        grid.item true
        grid.children [
          Mui.textField [
            textField.placeholder "Equipment ID (Asset Number)"
            textField.value equipment.EquipmentNumber
            textField.variant.filled
            textField.margin.normal
            textField.fullWidth true
            textField.label "Equipment ID (Asset Number)"
            textField.name "EquipmentNumber"
          ]
          Mui.textField [
            textField.placeholder "Zip Code (Equipment Location)"
            textField.value equipment.ZipCode
            textField.variant.filled
            textField.margin.normal
            textField.fullWidth true
            textField.label "Zip code (Equipment Location)"
            textField.name "ZipCode"
          ]
          Mui.textField [
            textField.value (sprintf "%s %s" equipment.Make equipment.Model)
            textField.variant.filled
            textField.margin.normal
            textField.fullWidth true
            textField.label "Make/Model"
            textField.name "MakeModel"
          ]
          Mui.textField [
            textField.value equipment.SerialNumber
            textField.variant.filled
            textField.margin.normal
            textField.fullWidth true
            textField.label "SerialNumber"
            textField.name "SerialNumber"
          ]
          if System.String.IsNullOrWhiteSpace equipment.Location
          then ()
          else
            Mui.textField [
              textField.value equipment.Location
              textField.variant.filled
              textField.margin.normal
              textField.fullWidth true
              textField.label "Location"
              textField.name "Location"
            ]
        ]
      ]
    ]
  ]